import { put } from 'redux-saga/effects'
import axios from '../../axios-conf'
import uris from '../../uris'
import {
  addNotification,
  leadSaveSuccess,
  leadSaveFailure,
  leadPatchSuccess,
  leadPatchFailure,
  socketEmit
} from '../actions'
import { uiConstants } from '../../constants'
import { uiHelper } from '../../helpers'

export function* leadSaveSaga(action) {
  try {
    const { data, options } = action.payload

    const c = data.c
    delete data.c

    const result = yield axios.post(`${uris.leadBaseUrl}${c}`, data)

    yield put(leadSaveSuccess(result.data))
    yield put(
      socketEmit({ event: 'change_state', data: { state: options.onSuccess } })
    )
  } catch (error) {
    yield put(leadSaveFailure(error))
    yield put(
      addNotification(
        uiHelper.errorMessage(error),
        uiConstants.notification.error
      )
    )
  }
}

export function* leadPatchSaga(action) {
  try {
    const data = action.payload

    const c = data.c
    delete data.c

    yield axios.patch(`${uris.leadBaseUrl}${c}`, data)
    yield put(leadPatchSuccess())
  } catch (error) {
    yield put(leadPatchFailure(error))
    yield put(
      addNotification(
        uiHelper.errorMessage(error),
        uiConstants.notification.error
      )
    )
  }
}
